import MsApiAbstract from '@services/api/ms'

class FirewallLogsApi extends MsApiAbstract {
    static search(api, mode, type, scopes, headers = {}, callback = null, execCallback = true) {
        return this.getProcess(api, {mode, type, scopes, headers, callback, execCallback})
    }
}

export default FirewallLogsApi
